/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_ActivateInputs */

const cs_sklik_activate = /** @type {(inputs: Sklik_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivovat`)
};

const en_sklik_activate = /** @type {(inputs: Sklik_ActivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activate`)
};

/**
* | output |
* | --- |
* | "Activate" |
*
* @param {Sklik_ActivateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_activate = /** @type {((inputs?: Sklik_ActivateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_ActivateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_activate(inputs)
	return cs_sklik_activate(inputs)
});